module.exports = __webpack_public_path__ + "static/media/calendar.4dac7728.svg";